export default __webpack_public_path__ + "static/media/steven-profile-pic.ab74fc6a.jpg";